export const DOCUMENT_STATUS = {
  PREPARING: 'PREPARING',
  FUTURE: 'FUTURE',
  PAST: 'PAST',
  CURRENT: 'CURRENT',
};

export const documentStatuses = [
  { id: DOCUMENT_STATUS.PREPARING, text: 'En préparation' },
  { id: DOCUMENT_STATUS.FUTURE, text: 'À venir' },
  { id: DOCUMENT_STATUS.PAST, text: 'Archivé' },
  { id: DOCUMENT_STATUS.CURRENT, text: 'Publié' },
];

export const DOCUMENT_TYPOLOGY = {
  NATIONAL: 'NATIONAL',
  REGIONAL: 'REGIONAL',
  AGENCY: 'AGENCY',
};

export const DOCUMENT_TYPOLOGY_NAME = {
  NATIONAL: 'National',
  REGIONAL: 'Régional',
  AGENCY: 'Zone de vente',
};

export const documentTypologies = [
  { id: DOCUMENT_TYPOLOGY.NATIONAL, text: DOCUMENT_TYPOLOGY_NAME.NATIONAL },
  { id: DOCUMENT_TYPOLOGY.REGIONAL, text: DOCUMENT_TYPOLOGY_NAME.REGIONAL },
  { id: DOCUMENT_TYPOLOGY.AGENCY, text: DOCUMENT_TYPOLOGY_NAME.AGENCY },
];

documentTypologies.forUser = (hasRegion, hasAgency) => {
  if (hasAgency) {
    return documentTypologies.filter(typo => typo.id === DOCUMENT_TYPOLOGY.AGENCY);
  } else if (hasRegion) {
    return documentTypologies.filter(typo => typo.id !== DOCUMENT_TYPOLOGY.NATIONAL);
  }
  return documentTypologies;
};

export const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const USER_STATUS_NAME = {
  ACTIVE: 'Actif',
  INACTIVE: 'Inactif',
};

export const userStatuses = [
  { id: USER_STATUS.ACTIVE, text: USER_STATUS_NAME.ACTIVE },
  { id: USER_STATUS.INACTIVE, text: USER_STATUS_NAME.INACTIVE },
];



// WEBPACK FOOTER //
// ./shared/src/utils/constants.js